import { useRef } from 'react';
import { useOverlayTrigger } from 'react-aria';
import { useOverlayTriggerState } from 'react-stately';

import { RouteManager } from '../../../RouteManager';

import { useI18n } from '../../../hooks/useI18nFormatters';
import { useVariablesAttach } from '../../../store/logic/useVariables';
import { useApi } from '../../../store/SelectedHomeyStore.hooks';

import { cssClass } from '../../../theme/cssClass';
import { suPx } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';

import { AnimationRemain } from '../../../components/animation/AnimationRemain';
import { MonoButtonRound } from '../../../components/buttons/MonoButtonRound';
import { Overlay } from '../../../components/overlay/Overlay';
import { PremiumLocked } from '../../../components/premium/PremiumLocked';

import { VariablesList } from './VariablesList';

export function VariablesButton(props) {
  useVariablesAttach();

  const { api, homey } = useApi();
  const { i18n } = useI18n();
  const triggerRef = useRef();
  const overlayTriggerState = useOverlayTriggerState({
    defaultOpen: props.defaultOpen,
  });

  const overlayTrigger = useOverlayTrigger({ type: 'listbox' }, overlayTriggerState, triggerRef);
  const isPremiumLocked =
    api?.tier !== 'premium' && homey?.platform !== undefined && homey?.platform !== 'local';

  return (
    <>
      <MonoButtonRound
        {...overlayTrigger.triggerProps}
        ref={triggerRef}
        styleCompact
        styleColor={isPremiumLocked ? 'disabled' : 'default'}
        styleIconColor={isPremiumLocked ? 'disabled' : 'default'}
        title={i18n.messageFormatter('logic.variablesTitle')}
        onPress={() => {
          if (isPremiumLocked) {
            RouteManager.toPremiumRequiredDialog();
            return;
          }

          overlayTriggerState.toggle();
        }}
      >
        <MonoButtonRound.Icon source={glyph.system.logic} />
        <MonoButtonRound.Text className={cssClass.showForLarge}>
          {i18n.messageFormatter('logic.variablesTitle')}
        </MonoButtonRound.Text>

        {isPremiumLocked && <PremiumLocked size={PremiumLocked.size.small} zIndex={2} />}
      </MonoButtonRound>

      <AnimationRemain condition={overlayTriggerState.isOpen} delay={200}>
        {(animationRemainProps) => {
          return (
            <Overlay
              targetRef={triggerRef}
              overlayProps={overlayTrigger.overlayProps}
              overlayTriggerState={overlayTriggerState}
              offset={suPx(1)}
              animationRemainProps={animationRemainProps}
            >
              <VariablesList
                onCloseRequest={() => {
                  overlayTriggerState.close();
                }}
              />
            </Overlay>
          );
        }}
      </AnimationRemain>
    </>
  );
}
